import React, { useEffect, useState } from 'react';

import './FancyBookView.scss';
import { connect } from 'react-redux';
import { RootState } from '../../../models/RootState';
import { UserBet } from '../../../models/ExchBetSlip';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';

type PropsType = {
  openBets: UserBet[];
  exposureMap?: any;
};

const FancyBookView: React.FC<PropsType> = (props) => {
  const { openBets, exposureMap } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [runsRiskMap, setRunsRiskMap] = useState<any>({});


  const getRiskValue = () => {
    let probableRunsList: any = [];
    if (exposureMap) {
      probableRunsList = Object.values(exposureMap).sort((a: any, b: any) => Number(b) - Number(a));
      let runsMap: any = {};
      for (let pr of probableRunsList) {
        runsMap[pr['runnerId']] = pr;
      }
      setRunsRiskMap(runsMap);
    }
  };

  useEffect(() => {
    setLoading(true);
    getRiskValue();
    setLoading(false);
  }, [openBets]);

  return (
    <div className="fancy-book-table-ctn">
      {loading ? null : (
        <>
          {exposureMap ? (
            <TableContainer component={Paper}>
              <Table className="fancy-book-table">
                <TableHead>
                  <TableRow>
                    <TableCell>Runner Name</TableCell>
                    <TableCell>Profit/Loss</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(runsRiskMap)
                    .sort((a, b) => Number(a) - Number(b))
                    .map((run: any, idx) => (
                      <TableRow key={idx}>
                        <TableCell key={'row-' + idx + 'cell-1'}>
                          {idx === 0
                            ? run + ' or Less'
                            : idx === Object.keys(runsRiskMap).length - 1
                              ? run + ' or More'
                              : run}
                        </TableCell>
                        <TableCell
                          key={'row-' + idx + 'cell-2'}
                          className={
                            runsRiskMap[run]?.userRisk > 0
                              ? 'profit'
                              : runsRiskMap[run]['userRisk'] < 0
                                ? 'loss'
                                : ""
                          }
                        >
                          {runsRiskMap[run]['userRisk'] > 0
                            ? '+' +
                            Number(runsRiskMap[run]['userRisk']).toFixed(2)
                            : Number(runsRiskMap[run]['userRisk']).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <div className="no-data">No data to display</div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    openBets: state.exchBetSlip.openBets,
  };
};

export default connect(mapStateToProps)(FancyBookView);
